import React, { Component } from 'react';
import { Message } from 'semantic-ui-react';
import moment from 'moment';

export default class TopMessage extends Component {
  render() {
    const { data } = this.props;

    if (!data.HasPrintedResults) {
      return (
        <Message negative>
          <Message.Content>
            Verification cannot be closed until all Verification Results Letters
            have been printed.
          </Message.Content>
        </Message>
      );
    }

    if (
      !data.HasStudentCountsRun ||
      moment().diff(data.AsOfDate_Student, 'hours') < 0
    ) {
      return (
        <Message negative>
          <Message.Content>
            Verification cannot be closed until after the Student count is run
            on {moment(data.AsOfDate_Student).format('MM/DD/YYYY')}.
          </Message.Content>
        </Message>
      );
    }

    if (data.IsComplete) {
      return (
        <Message negative>
          <Message.Content>Verification is closed.</Message.Content>
        </Message>
      );
    }

    return null;
  }
}



// WEBPACK FOOTER //
// ./src/pages/verificationclose/components/TopMessage.js